// src/icons/Icon.js
import React from 'react';

const Icon = ({ name, width = 16, height = 16 }) => {
  const icons = {
    dashboard: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 20 20">
        <defs>
          <clipPath id="dashboardsvg">
            <rect id="Rectangle_1" data-name="Rectangle 1" width="20" height="20" transform="translate(5770 966)" strokeLinecap="round" strokeWidth="1"></rect>
          </clipPath>
        </defs>
        <g className="svg-stroke-color" id="dashboard_1" data-name="dashboard 1" transform="translate(-5770 -966)" clipPath="url(#dashboardsvg)">
          <path id="Path_5" data-name="Path 5" d="M0,2.929V0H6V6H0" transform="translate(5778.5 977.511) rotate(90)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
          <path id="Path_18" data-name="Path 18" d="M0,2.929V0H6V6H0" transform="translate(5781.5 974.511) rotate(-90)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
          <path id="Path_17" data-name="Path 17" d="M0,2.929V0H6V6H0" transform="translate(5781.5 977.511)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
          <path id="Path_19" data-name="Path 19" d="M6,3.071V6H0V0H6" transform="translate(5772.5 968.511)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
        </g>
      </svg>
    ),
    orders: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 20 20">
        <defs>
          <clipPath id="tablessvg">
            <rect id="Rectangle_15" data-name="Rectangle 15" width="20" height="20" transform="translate(5770 1035)" fill="#fff"></rect>
          </clipPath>
        </defs>
        <g id="tables_1" data-name="tables 1" transform="translate(-5770 -1035)" clipPath="url(#tablessvg)">
          <path className="svg-stroke-color" id="Path_65" data-name="Path 65" d="M5780,1042.981v8.648" transform="translate(0 -0.461)" fill="none" stroke="#333" strokeLinecap="round" strokeWidth="2"></path>
          <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(5771 1038.303)" fill="none" strokeWidth="2">
            <ellipse className="svg-fill-stroke-none" cx="9" cy="2.5" rx="9" ry="2.5" stroke="none"></ellipse>
            <ellipse className="svg-stroke-color" cx="9" cy="2.5" rx="8" ry="1.5" fill="none"></ellipse>
          </g>
          <path className="svg-stroke-color" id="Path_66" data-name="Path 66" d="M5776.367,1052.393h6.981" transform="translate(0.142 -0.697)" fill="none" stroke="#333" strokeLinecap="round" strokeWidth="2"></path>
        </g>
      </svg>
    ),
    reports: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 20 20">
        <defs>
          <clipPath id="reportsvg">
            <rect id="Rectangle_39" data-name="Rectangle 39" width="20" height="20" transform="translate(5770 1086)" fill="#fff"></rect>
          </clipPath>
        </defs>
        <g id="reports_1" data-name="reports 1" transform="translate(-5770 -1086)" clipPath="url(#reportsvg)">
          <path className="svg-stroke-color" id="Path_99" data-name="Path 99" d="M5774.489,1089.638h11.585v12.731h-11.585v-9.835" transform="translate(-0.281 -0.004)" fill="none" stroke="#333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
          <path className="svg-stroke-color" id="Path_100" data-name="Path 100" d="M5777.506,1093.44h5.309" transform="translate(-0.281 -0.004)" fill="none" stroke="#333" strokeLinecap="round" strokeWidth="2"></path>
          <path className="svg-stroke-color" id="Path_101" data-name="Path 101" d="M5777.506,1093.44h5.309" transform="translate(-0.281 2.56)" fill="none" stroke="#333" strokeLinecap="round" strokeWidth="2"></path>
          <path className="svg-stroke-color" id="Path_102" data-name="Path 102" d="M5777.506,1093.44h5.309" transform="translate(-0.281 5.125)" fill="none" stroke="#333" strokeLinecap="round" strokeWidth="2"></path>
        </g>
      </svg>
    ),
    locations: (

      <svg
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
        fill="#212121"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path
            fill="#212121"
            d="M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32z"
          ></path>
          <path
            fill="#212121"
            d="M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416zM512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544z"
          ></path>
          <path
            fill="#212121"
            d="M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192zm0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320z"
          ></path>
        </g>
      </svg>
    ),
    organizations: (
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="#212121"
        stroke="#212121"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M22 4H12V2H5v2H2v18H0v1h11v-5h2v5h11v-1h-2zm-8 18v-5h-4v5H3V5h3V3h5v2h10v17zM5 11h4V7H5zm1-3h2v2H6zm4 3h4V7h-4zm1-3h2v2h-2zm4 3h4V7h-4zm1-3h2v2h-2zM5 16h4v-4H5zm1-3h2v2H6zm4 3h4v-4h-4zm1-3h2v2h-2zm4 3h4v-4h-4zm1-3h2v2h-2z"></path>
          <path fill="none" d="M0 0h24v24H0z"></path>
        </g>
      </svg>
    ),
    countries: (
      <svg
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            clipRule="evenodd"
            d="M10 7.88974C11.1046 7.88974 12 6.98912 12 5.87814C12 4.76716 11.1046 3.86654 10 3.86654C8.89543 3.86654 8 4.76716 8 5.87814C8 6.98912 8.89543 7.88974 10 7.88974ZM10 6.5822C10.3866 6.5822 10.7 6.26698 10.7 5.87814C10.7 5.4893 10.3866 5.17408 10 5.17408C9.6134 5.17408 9.3 5.4893 9.3 5.87814C9.3 6.26698 9.6134 6.5822 10 6.5822Z"
            fill="#000000"
            fillRule="evenodd"
          ></path>
          <path
            clipRule="evenodd"
            d="M5.15 5.62669C5.15 3.0203 7.37393 1 10 1C12.6261 1 14.85 3.0203 14.85 5.62669C14.85 6.06012 14.8114 6.53528 14.7269 7.03578L18 7.8588L25.7575 5.90818C26.0562 5.83306 26.3727 5.90057 26.6154 6.09117C26.8581 6.28178 27 6.57423 27 6.88395V23.9826C27 24.4441 26.6877 24.8464 26.2425 24.9584L18.2425 26.97C18.0833 27.01 17.9167 27.01 17.7575 26.97L10 25.0193L2.24254 26.97C1.94379 27.0451 1.6273 26.9776 1.38459 26.787C1.14187 26.5964 1 26.3039 1 25.9942V8.89555C1 8.43402 1.3123 8.03172 1.75746 7.91978L5.2731 7.03578C5.18863 6.53528 5.15 6.06012 5.15 5.62669ZM10 2.70986C8.20779 2.70986 6.85 4.06691 6.85 5.62669C6.85 7.21686 7.5125 9.57287 9.40979 11.3615C9.74241 11.6751 10.2576 11.6751 10.5902 11.3615C12.4875 9.57287 13.15 7.21686 13.15 5.62669C13.15 4.06691 11.7922 2.70986 10 2.70986ZM5.80904 8.97453L3.22684 9.62382C3.09349 9.65735 3 9.77726 3 9.91476V24.3212C3 24.5165 3.18371 24.6598 3.37316 24.6121L8.77316 23.2543C8.90651 23.2208 9 23.1009 9 22.9634V13.2506C7.40353 12.024 6.39235 10.4792 5.80904 8.97453ZM11 13.2506V22.9634C11 23.1009 11.0935 23.2208 11.2268 23.2543L16.6268 24.6121C16.8163 24.6598 17 24.5165 17 24.3212V9.91477C17 9.77726 16.9065 9.65735 16.7732 9.62382L14.191 8.97453C13.6076 10.4792 12.5965 12.024 11 13.2506ZM25 22.9634C25 23.1009 24.9065 23.2208 24.7732 23.2543L19.3732 24.6121C19.1837 24.6598 19 24.5165 19 24.3212V9.91477C19 9.77726 19.0935 9.65736 19.2268 9.62382L24.6268 8.26599C24.8163 8.21835 25 8.36159 25 8.55693V22.9634Z"
            fill="#000000"
            fillRule="evenodd"
          ></path>
        </g>
      </svg>
    ),
    cities: (
      <svg
        fill="#000000"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M12 6L12 24L19 24L19 12L24 12L24 6L12 6 z M 15 8L17 8L17 10L15 10L15 8 z M 19 8L21 8L21 10L19 10L19 8 z M 15 12L17 12L17 14L15 14L15 12 z M 21 14L21 39L28 39L28 20L34 20L34 14L21 14 z M 15 16L17 16L17 18L15 18L15 16 z M 24 16L26 16L26 18L24 18L24 16 z M 29 16L31 16L31 18L29 18L29 16 z M 15 20L17 20L17 22L15 22L15 20 z M 24 20L26 20L26 22L24 22L24 20 z M 30 22L30 39L42 39L42 22L30 22 z M 24 24L26 24L26 26L24 26L24 24 z M 33 24L35 24L35 26L33 26L33 24 z M 37 24L39 24L39 26L37 26L37 24 z M 8 26L8 39L19 39L19 26L8 26 z M 11 28L13 28L13 30L11 30L11 28 z M 15 28L17 28L17 30L15 30L15 28 z M 24 28L26 28L26 30L24 30L24 28 z M 33 28L35 28L35 30L33 30L33 28 z M 37 28L39 28L39 30L37 30L37 28 z M 6 30.919922L-0.029296875 45L50.140625 45L44 31.839844L44 41L6 41L6 30.919922 z M 11 32L13 32L13 34L11 34L11 32 z M 15 32L17 32L17 34L15 34L15 32 z M 24 32L26 32L26 34L24 34L24 32 z M 33 32L35 32L35 34L33 34L33 32 z M 37 32L39 32L39 34L37 34L37 32 z"></path>
        </g>
      </svg>
    ),
    states: (
      <svg
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            clipRule="evenodd"
            d="M10 7.88974C11.1046 7.88974 12 6.98912 12 5.87814C12 4.76716 11.1046 3.86654 10 3.86654C8.89543 3.86654 8 4.76716 8 5.87814C8 6.98912 8.89543 7.88974 10 7.88974ZM10 6.5822C10.3866 6.5822 10.7 6.26698 10.7 5.87814C10.7 5.4893 10.3866 5.17408 10 5.17408C9.6134 5.17408 9.3 5.4893 9.3 5.87814C9.3 6.26698 9.6134 6.5822 10 6.5822Z"
            fill="#000000"
            fillRule="evenodd"
          ></path>
          <path
            clipRule="evenodd"
            d="M5.15 5.62669C5.15 3.0203 7.37393 1 10 1C12.6261 1 14.85 3.0203 14.85 5.62669C14.85 6.06012 14.8114 6.53528 14.7269 7.03578L18 7.8588L25.7575 5.90818C26.0562 5.83306 26.3727 5.90057 26.6154 6.09117C26.8581 6.28178 27 6.57423 27 6.88395V23.9826C27 24.4441 26.6877 24.8464 26.2425 24.9584L18.2425 26.97C18.0833 27.01 17.9167 27.01 17.7575 26.97L10 25.0193L2.24254 26.97C1.94379 27.0451 1.6273 26.9776 1.38459 26.787C1.14187 26.5964 1 26.3039 1 25.9942V8.89555C1 8.43402 1.3123 8.03172 1.75746 7.91978L5.2731 7.03578C5.18863 6.53528 5.15 6.06012 5.15 5.62669ZM10 2.70986C8.20779 2.70986 6.85 4.06691 6.85 5.62669C6.85 7.21686 7.5125 9.57287 9.40979 11.3615C9.74241 11.6751 10.2576 11.6751 10.5902 11.3615C12.4875 9.57287 13.15 7.21686 13.15 5.62669C13.15 4.06691 11.7922 2.70986 10 2.70986ZM5.80904 8.97453L3.22684 9.62382C3.09349 9.65735 3 9.77726 3 9.91476V24.3212C3 24.5165 3.18371 24.6598 3.37316 24.6121L8.77316 23.2543C8.90651 23.2208 9 23.1009 9 22.9634V13.2506C7.40353 12.024 6.39235 10.4792 5.80904 8.97453ZM11 13.2506V22.9634C11 23.1009 11.0935 23.2208 11.2268 23.2543L16.6268 24.6121C16.8163 24.6598 17 24.5165 17 24.3212V9.91477C17 9.77726 16.9065 9.65735 16.7732 9.62382L14.191 8.97453C13.6076 10.4792 12.5965 12.024 11 13.2506ZM25 22.9634C25 23.1009 24.9065 23.2208 24.7732 23.2543L19.3732 24.6121C19.1837 24.6598 19 24.5165 19 24.3212V9.91477C19 9.77726 19.0935 9.65736 19.2268 9.62382L24.6268 8.26599C24.8163 8.21835 25 8.36159 25 8.55693V22.9634Z"
            fill="#000000"
            fillRule="evenodd"
          ></path>
        </g>
      </svg>
    ),
    labmanagement: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 20 20">
        <defs>
          <clipPath id="menusvg">
            <rect
              id="Rectangle_36"
              data-name="Rectangle 36"
              width="20"
              height="20"
              fill="#fff"
            ></rect>
          </clipPath>
        </defs>
        <g id="menu_1" data-name="menu 1" clipPath="url(#menusvg)">
          <g
            id="Ellipse_9"
            data-name="Ellipse 9"
            transform="translate(2.09 14.5)"
            fill="#fff"
            stroke="#333"
            strokeWidth="1"
          >
            <circle className="svg-fill-color" cx="1" cy="1" r="1" stroke="none"></circle>
            <circle
              className="svg-stroke-color"
              cx="1"
              cy="1"
              r="0.5"
              fill="none"
            ></circle>
          </g>
          <path
            className="svg-stroke-color"
            id="Path_85"
            data-name="Path 85"
            d="M5820.286,1075.157h-11.3"
            transform="translate(-5802.376 -1059.657)"
            fill="none"
            stroke="#333"
            strokeLinecap="round"
            strokeWidth="2"
          ></path>
          <path
            className="svg-stroke-color"
            id="Path_86"
            data-name="Path 86"
            d="M5823.8,1075.157h-14.82"
            transform="translate(-5805.895 -1065.157)"
            fill="none"
            stroke="#333"
            strokeLinecap="round"
            strokeWidth="2"
          ></path>
          <path
            className="svg-stroke-color"
            id="Path_87"
            data-name="Path 87"
            d="M5823.8,1075.157h-14.82"
            transform="translate(-5805.895 -1070.657)"
            fill="none"
            stroke="#333"
            strokeLinecap="round"
            strokeWidth="2"
          ></path>
        </g>
      </svg>
    ),
    usermanagement: (
      <svg
        fill="#212121"
        viewBox="0 0 14 14"
        role="img"
        focusable="false"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="18" // You can adjust the width and height as needed
        height="18"
      >
        <path d="m 12.448083,9.199605 c 0.04875,-0.2644 0.04875,-0.53443 0,-0.79883 l 0.483801,-0.27941 c 0.05626,-0.0319 0.08063,-0.0975 0.06188,-0.15939 -0.125638,-0.40504 -0.341286,-0.77258 -0.622565,-1.07636 -0.04313,-0.0469 -0.112512,-0.0581 -0.168768,-0.0263 l -0.483801,0.27941 c -0.204397,-0.17439 -0.438796,-0.30941 -0.691948,-0.39942 l 0,-0.55881 c 0,-0.0637 -0.045,-0.12001 -0.106886,-0.13314 -0.41817,-0.0938 -0.843839,-0.09 -1.2413813,0 -0.061882,0.0131 -0.1068863,0.0694 -0.1068863,0.13314 l 0,0.55881 c -0.2531517,0.09 -0.4875514,0.22503 -0.6919479,0.39942 l -0.483801,-0.27941 c -0.054381,-0.0319 -0.1256383,-0.0206 -0.1687678,0.0263 -0.2812797,0.30378 -0.4969274,0.67132 -0.6225656,1.07636 -0.018752,0.0619 0.0075,0.12751 0.061882,0.15939 l 0.483801,0.27941 c -0.048755,0.2644 -0.048755,0.53443 0,0.79883 l -0.483801,0.27941 c -0.056256,0.0319 -0.080634,0.0975 -0.061882,0.15939 0.1256382,0.40504 0.3412859,0.7707 0.6225656,1.07636 0.04313,0.0469 0.1125119,0.0581 0.1687678,0.0263 l 0.483801,-0.2794 c 0.2043965,0.17439 0.4387962,0.30941 0.6919479,0.39942 l 0,0.5588 c 0,0.0638 0.045005,0.12002 0.1068863,0.13314 0.4181693,0.0938 0.8438393,0.09 1.2413813,0 0.06188,-0.0131 0.106886,-0.0694 0.106886,-0.13314 l 0,-0.5588 c 0.253152,-0.09 0.487551,-0.22503 0.691948,-0.39942 l 0.483801,0.2794 c 0.05438,0.0319 0.125638,0.0206 0.168768,-0.0263 0.281279,-0.30378 0.496927,-0.67132 0.622565,-1.07636 0.01875,-0.0619 -0.0075,-0.12752 -0.06188,-0.15939 l -0.483801,-0.27941 z m -2.147102,0.51005 c -0.5025526,0 -0.9094705,-0.40879 -0.9094705,-0.90947 0,-0.50067 0.4087931,-0.90947 0.9094705,-0.90947 0.500678,0 0.909471,0.4088 0.909471,0.90947 0,0.50068 -0.406918,0.90947 -0.909471,0.90947 z M 5.2004436,6.999995 c 1.3257648,0 2.4002531,-1.07448 2.4002531,-2.40025 0,-1.32576 -1.0744883,-2.40025 -2.4002531,-2.40025 -1.3257647,0 -2.400253,1.07449 -2.400253,2.40025 0,1.32577 1.0744883,2.40025 2.400253,2.40025 z m 3.7728978,4.24733 c -0.04313,-0.0225 -0.086259,-0.0488 -0.1275135,-0.0731 l -0.1481406,0.0863 c -0.1125118,0.0638 -0.2400253,0.0994 -0.3675387,0.0994 -0.2043966,0 -0.4012923,-0.0863 -0.5419322,-0.23628 C 7.4450553,10.752355 7.1825276,10.300435 7.034387,9.818515 6.9312511,9.486605 7.070016,9.135935 7.3700473,8.961545 l 0.1481407,-0.0863 c -0.00188,-0.0487 -0.00188,-0.0975 0,-0.14626 L 7.3700473,8.642685 C 7.0700157,8.470165 6.9312511,8.117625 7.034387,7.785715 c 0.016877,-0.0544 0.041254,-0.10876 0.060006,-0.16314 -0.071257,-0.006 -0.1406398,-0.0225 -0.2137725,-0.0225 l -0.3131581,0 c -0.4162938,0.19127 -0.8794677,0.30003 -1.3670191,0.30003 -0.4875514,0 -0.94885,-0.10876 -1.3670191,-0.30003 l -0.313158,0 c -1.3913964,-1e-5 -2.5202654,1.12886 -2.5202654,2.52025 l 0,0.78009 c 0,0.49692 0.4031675,0.90009 0.9000949,0.90009 l 6.6006959,0 c 0.1893949,0 0.3656635,-0.06 0.5100537,-0.15939 -0.022502,-0.0713 -0.037504,-0.14439 -0.037504,-0.22128 l 0,-0.17251 z"></path>
      </svg>
    ),
    deliveryagent: (
      <svg

        viewBox="0 0 48 48"

        xmlns="http://www.w3.org/2000/svg"

        width="18"

        height="18"

        fill="#212121"
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="invisible_box" data-name="invisible box">
            <rect width="48" height="48" fill="none" />
          </g>
          <g id="Health_Icons" data-name="Health Icons">
            <g>
              <path d="M37.7,11.1A3,3,0,0,0,35.4,10H34.2l.3-1.7A3.1,3.1,0,0,0,33.9,6a3.2,3.2,0,0,0-2.2-1H7.8a2,2,0,0,0,0,4H30.3l-4,22.9a6.8,6.8,0,0,0-1,2.1H20.7A7,7,0,0,0,7.3,34H6.2l.5-2.9a2,2,0,0,0-1.6-2.3,2,2,0,0,0-2.3,1.6L2,34.7A2.8,2.8,0,0,0,2.7,37a2.8,2.8,0,0,0,2.1,1H7.3a7,7,0,0,0,13.4,0h4.6a7,7,0,0,0,13.4,0h2a3.2,3.2,0,0,0,3.1-2.7L46,22.5ZM14,39a3,3,0,0,1-3-3,3,3,0,0,1,6,0A3,3,0,0,1,14,39ZM33.5,14h1.3l5.9,8H32.1ZM32,39a3,3,0,0,1-3-3,3,3,0,0,1,6,0A3,3,0,0,1,32,39Zm8-5H38.7A7,7,0,0,0,32,29H30.9l.5-3.1h9.9Z" />
              <path d="M4,15H14a2,2,0,0,0,0-4H4a2,2,0,0,0,0,4Z" />
              <path d="M15,19a2,2,0,0,0-2-2H5a2,2,0,0,0,0,4h8A2,2,0,0,0,15,19Z" />
              <path d="M6,23a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4Z" />
            </g>
          </g>
        </g>
      </svg>

    ),
    samplecollection: (
      <svg
        fill="#000000"
        height="200px"
        width="200px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 297 297"
        xmlSpace="preserve"
      >
        <g>
          <path d="M294.081,72.683L224.316,2.918c-3.891-3.889-10.2-3.891-14.095,0l-23.256,23.255c-1.869,1.869-2.919,4.404-2.919,7.047 
        s1.05,5.178,2.919,7.047l4.581,4.581L12.552,223.843C4.458,231.936,0,242.698,0,254.144c0,11.447,4.458,22.208,12.552,30.303 
        c8.094,8.094,18.857,12.552,30.303,12.552s22.208-4.458,30.302-12.552l178.995-178.995l4.581,4.581 
        c1.87,1.869,4.404,2.919,7.047,2.919c2.643,0,5.179-1.05,7.047-2.919l23.255-23.256C297.973,82.886,297.973,76.575,294.081,72.683z 
        M59.062,270.353c-4.329,4.33-10.085,6.714-16.207,6.714s-11.879-2.384-16.208-6.714c-4.33-4.329-6.714-10.086-6.714-16.208 
        c0-6.123,2.384-11.878,6.714-16.207l120.856-120.856l32.416,32.416L59.062,270.353z M194.013,135.402l-32.416-32.416l44.044-44.044 
        l32.416,32.416L194.013,135.402z M263.779,88.892L208.108,33.22l9.161-9.161l55.671,55.671L263.779,88.892z"></path>
        </g>
      </svg>

    ),
    laboratory: (
      <svg
        fill="#000000"
        height="200px"
        width="200px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 381.669 381.669"
        xmlSpace="preserve"
      >
        <g>
          <path d="M310.237,337.919h-21.16l-5.988-173.524c-0.04-33.845-15.758-44.933-21.68-49.111c-0.27-0.19-23.414-15.993-23.414-15.993
          l4.646-7.9c2.1-3.569,0.908-8.167-2.662-10.268l-4.429-2.605l11.48-19.519l6.673,3.925c1.163,0.684,2.477,1.035,3.803,1.035
          c0.63,0,1.263-0.079,1.883-0.24c1.925-0.499,3.573-1.743,4.582-3.458l11.065-18.814c2.1-3.57,0.908-8.166-2.662-10.267
          L221.128,1.036c-1.716-1.01-3.761-1.296-5.686-0.795c-1.925,0.499-3.573,1.743-4.582,3.458l-11.066,18.814
          c-2.1,3.57-0.908,8.166,2.662,10.267l6.672,3.924l-11.481,19.52l-4.429-2.606c-1.716-1.009-3.76-1.298-5.686-0.795
          c-1.925,0.499-3.573,1.743-4.582,3.457l-72.42,123.127c-2.1,3.57-0.908,8.167,2.662,10.268l8.074,4.749l-13.872,23.585
          c-1.009,1.715-1.294,3.76-0.795,5.687c0.499,1.925,1.743,3.572,3.458,4.581l17.685,10.4c1.194,0.702,2.503,1.036,3.795,1.036
          c2.57,0,5.074-1.322,6.472-3.698l13.871-23.584l8.073,4.748c1.163,0.684,2.477,1.035,3.803,1.035c0.63,0,1.263-0.079,1.883-0.24
          c1.925-0.499,3.573-1.743,4.582-3.457l11.214-19.064l18.146,10.674c4.689,2.758,8.024,7.178,9.391,12.446
          c1.365,5.267,0.599,10.751-2.16,15.44l-32.244,54.823l-12.668-7.451l1.851-3.146c2.1-3.57,0.908-8.167-2.662-10.268
          l-92.84-54.605c-1.716-1.009-3.761-1.296-5.686-0.794c-1.926,0.498-3.574,1.742-4.582,3.457L46.679,235.25
          c-2.1,3.57-0.907,8.167,2.663,10.267l14.065,8.273l-6.793,11.549c-2.1,3.571-0.908,8.168,2.662,10.268l51.776,30.453
          c1.163,0.684,2.477,1.035,3.803,1.035c0.63,0,1.263-0.079,1.883-0.24c1.925-0.499,3.573-1.743,4.582-3.458l6.793-11.55
          l7.619,4.48l-24.479,41.592H74.292c-14.22,0-25.789,11.569-25.789,25.789v10.461c0,4.143,3.357,7.5,7.5,7.5h272.523
          c4.143,0,7.5-3.357,7.5-7.5v-10.461C336.026,349.488,324.457,337.919,310.237,337.919z" />
        </g>
      </svg>

    ),
    laboratoryusers: (
      <svg
        fill="#000000"
        height="200px"
        width="200px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 496 496"
      >
        <g>
          <rect x="232" y="448" width="56" height="16"></rect>
          <path d="M448,318.36V208h16v-16h-96v16h16v110.36l-13.152,30.696c-14.136-14.728-32.248-25.12-52.28-29.568L256,305.584v-19.768 
          c24.176-17.448,40-45.784,40-77.816v-21.576l12.904-19.36C321.4,148.32,328,126.512,328,104c0-28.336-21.16-51.824-48.504-55.504 
          C275.824,21.16,252.336,0,224,0h-48C118.656,0,72,46.656,72,104c0,22.512,6.6,44.32,19.096,63.064L104,186.424V208 
          c0,32.032,15.824,60.368,40,77.816v19.768L81.44,319.48C33.488,330.144,0,371.88,0,421.008V496h400v-32h68.088 
          C483.48,464,496,451.48,496,436.088c0-3.808-0.76-7.504-2.256-10.992L448,318.36z"
          />
          <path d="M472,184c13.232,0,24-10.768,24-24s-10.768-24-24-24s-24,10.768-24,24S458.768,184,472,184z M472,152 
          c4.416,0,8,3.584,8,8s-3.584,8-8,8c-4.416,0-8-3.584-8-8S467.584,152,472,152z"
          />
          <path d="M392,152c17.648,0,32-14.352,32-32s-14.352-32-32-32s-32,14.352-32,32S374.352,152,392,152z M392,104 
          c8.824,0,16,7.176,16,16s-7.176,16-16,16c-8.824,0-16-7.176-16-16C376,111.176,383.176,104,392,104z"
          />
        </g>
      </svg>

    ),
    offers: (
      <svg
        fill="#000000"
        height="200px"
        width="200px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <g>
          <g>
            <path d="M92.164,186.126c-7.384,0-11.67,3.573-11.67,11.433v33.824c0,7.861,4.287,11.433,11.67,11.433c7.385,0,11.911-3.573,11.911-11.433V197.56C104.075,189.699,99.549,186.126,92.164,186.126z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M201.498,262.825c-7.384,0-11.671,3.573-11.671,11.433v33.824c0,7.86,4.289,11.433,11.671,11.433s11.91-3.573,11.91-11.433v-33.824C213.407,266.399,208.882,262.825,201.498,262.825z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M496.607,94.801H337.077l-0.736,0.736l13.112,13.112c10.517,10.517,10.517,27.63,0,38.147l-13.112,13.112l13.112,13.112c10.517,10.517,10.517,27.63,0,38.147l-13.112,13.112l13.112,13.112c10.517,10.517,10.517,27.63,0,38.147l-13.112,13.112l13.112,13.112c10.517,10.517,10.517,27.63,0,38.147l-13.112,13.112l13.112,13.112c5.096,5.094,7.901,11.868,7.901,19.073c0,7.206-2.806,13.98-7.901,19.074l-12.919,12.92h160.072c8.501,0,15.393-6.892,15.393-15.393V110.195C512,101.693,505.108,94.801,496.607,94.801z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M321.306,192.095l-13.112-13.112c-5.096-5.094-7.901-11.868-7.901-19.073c0-7.206,2.806-13.98,7.901-19.074l13.112-13.112l-13.112-13.112c-5.445-5.445-8.046-12.658-7.853-19.809H15.393C6.892,94.801,0,101.693,0,110.195v291.611c0,8.501,6.892,15.393,15.393,15.393h284.905c0.049-7.132,2.846-13.832,7.896-18.881l13.112-13.112l-13.112-13.112c-10.517-10.517-10.517-27.63,0-38.147l13.112-13.112l-13.112-13.112c-10.517-10.517-10.517-27.63,0-38.147l13.112-13.112l-13.112-13.112c-10.517-10.517-10.517-27.63,0-38.147L321.306,192.095z M56.436,231.384V197.56c0-23.581,15.484-32.157,35.73-32.157c20.009,0,35.731,8.576,35.731,32.157v33.824c0,23.582-15.722,32.157-35.731,32.157C71.919,263.54,56.436,254.965,56.436,231.384z M106.219,350.482c-8.099,0-13.339-6.669-13.339-12.624c0-1.429,0.476-3.096,1.191-4.526l83.606-171.739c1.906-4.049,5.717-5.955,10.004-5.955c6.669,0,14.053,5.002,14.053,12.624c0,1.429-0.238,3.096-0.952,4.526l-83.846,171.739C115.27,348.1,110.744,350.482,106.219,350.482z M237.226,308.083c0,23.582-15.721,32.157-35.73,32.157c-20.246,0-35.73-8.575-35.73-32.157v-33.824c0-23.582,15.482-32.157,35.73-32.157c20.009,0,35.73,8.575,35.73,32.157V308.083z"></path>
          </g>
        </g>
      </svg>

    ),

    signature: (
      <svg
        width="206px"
        height="206px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 9.00006H6.2C5.0799 9.00006 4.51984 9.00006 4.09202 9.21805C3.71569 9.40979 3.40973 9.71575 3.21799 10.0921C3 10.5199 3 11.08 3 12.2001V17.8001C3 18.9202 3 19.4802 3.21799 19.908C3.40973 20.2844 3.71569 20.5903 4.09202 20.7821C4.51984 21.0001 5.07989 21.0001 6.2 21.0001H17.787C18.9071 21.0001 19.4671 21.0001 19.895 20.7821C20.2713 20.5903 20.5772 20.2844 20.769 19.908C20.987 19.4802 20.987 18.9202 20.987 17.8001V12.0001M6 15.0001H6.01M10 15H10.01M11.5189 12.8946L12.8337 12.6347C13.5432 12.4945 13.8979 12.4244 14.2287 12.2953C14.5223 12.1807 14.8013 12.0318 15.06 11.8516C15.3514 11.6487 15.607 11.393 16.1184 10.8816L21.2668 5.73321C21.9541 5.04596 21.9541 3.9317 21.2668 3.24444C20.5796 2.55719 19.4653 2.55719 18.7781 3.24445L13.5416 8.48088C13.0625 8.96004 12.8229 9.19963 12.6294 9.47121C12.4576 9.71232 12.3131 9.97174 12.1986 10.2447C12.0696 10.5522 11.9921 10.8821 11.837 11.5417L11.5189 12.8946Z"
          stroke="#000000"
          strokeWidth="0.552"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

    ),
    banners: (
      <svg
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        fill="#000000"
        stroke="#000000"
        strokeWidth="1.152"
      >
        <g strokeWidth="0"></g>
        <g strokeLinecap="round" strokeLinejoin="round"></g>
        <g>
          <path
            d="M29.4995,12.3739c.7719-.0965,1.5437,.4824,1.5437,1.2543h0l2.5085,23.8312c.0965,.7719-.4824,1.5437-1.2543,1.5437l-23.7347,2.5085c-.7719,.0965-1.5437-.4824-1.5437-1.2543h0l-2.5085-23.7347c-.0965-.7719,.4824-1.5437,1.2543-1.5437l23.7347-2.605Z"
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.9045,18.9347c-1.7367,.193-3.0874,1.7367-2.8945,3.5699,.193,1.7367,1.7367,3.0874,3.5699,2.8945,1.7367-.193,3.0874-1.7367,2.8945-3.5699s-1.8332-3.0874-3.5699-2.8945h0Zm8.7799,5.596l-4.6312,5.6925c-.193,.193-.4824,.2894-.6754,.0965h0l-1.0613-.8683c-.193-.193-.5789-.0965-.6754,.0965l-5.0171,6.1749c-.193,.193-.193,.5789,.0965,.6754-.0965,.0965,.0965,.0965,.193,.0965l19.9719-2.1226c.2894,0,.4824-.2894,.4824-.5789,0-.0965-.0965-.193-.0965-.2894l-7.8151-9.0694c-.2894-.0965-.5789-.0965-.7719,.0965h0Z"
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.2814,13.8211l.6754-6.0784c.0965-.7719,.7719-1.3508,1.5437-1.2543l23.7347,2.5085c.7719,.0965,1.3508,.7719,1.2543,1.5437h0l-2.5085,23.7347c0,.6754-.7719,1.2543-1.5437,1.2543l-6.1749-.6754"
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.7799,29.9337l5.3065,.5789c.2894,0,.4824-.193,.5789-.4824,0-.0965,0-.193-.0965-.2894l-5.789-10.5166c-.0965-.193-.4824-.2894-.6754-.193h0l-.3859,.3859"
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    ),
    collectionagent: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#000000"
        strokeWidth="0.00024"
      >
        <g strokeWidth="0"></g>
        <g strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC" strokeWidth="0.048"></g>
        <g>
          <path
            d="M20 15C20.5523 15 21 14.5523 21 14C21 13.4477 20.5523 13 20 13C19.4477 13 19 13.4477 19 14C19 14.5523 19.4477 15 20 15Z"
            fill="#0F0F0F"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.775 0.985398C18.4919 0.460783 20.2821 1.55148 20.6033 3.3178L20.9362 5.14896C22.1346 5.54225 23 6.67006 23 8V10.7639C23.6137 11.3132 24 12.1115 24 13V15C24 15.8885 23.6137 16.6868 23 17.2361V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V8C1 6.51309 2.08174 5.27884 3.50118 5.04128L16.775 0.985398ZM21 16C21.5523 16 22 15.5523 22 15V13C22 12.4477 21.5523 12 21 12H18C17.4477 12 17 12.4477 17 13V15C17 15.5523 17.4477 16 18 16H21ZM21 18V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V8C3 7.44772 3.44772 7 4 7H20C20.55 7 20.9962 7.44396 21 7.99303L21 10H18C16.3431 10 15 11.3431 15 13V15C15 16.6569 16.3431 18 18 18H21ZM18.6954 3.60705L18.9412 5H10L17.4232 2.82301C17.9965 2.65104 18.5914 3.01769 18.6954 3.60705Z"
            fill="#0F0F0F"
          />
        </g>
      </svg>
    ),
    refund: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <text
          x="1"
          y="21"
          fontSize="24"
          fontFamily="Arial, sans-serif"
          fill="#0F0F0F"
        >
          ₹
        </text>
      </svg>
    ),
    leaveshistory: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 3V6M17 3V6M7.10002 20C7.56329 17.7178 9.58104 16 12 16C14.419 16 16.4367 17.7178 16.9 20M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21ZM14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11Z"
          stroke="#000000"
          strokeWidth="0.648"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    users: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 6.5C1.5 3.46243 3.96243 1 7 1C10.0376 1 12.5 3.46243 12.5 6.5C12.5 9.53757 10.0376 12 7 12C3.96243 12 1.5 9.53757 1.5 6.5Z"
          fill="#000000"
        />
        <path
          d="M14.4999 6.5C14.4999 8.00034 14.0593 9.39779 13.3005 10.57C14.2774 11.4585 15.5754 12 16.9999 12C20.0375 12 22.4999 9.53757 22.4999 6.5C22.4999 3.46243 20.0375 1 16.9999 1C15.5754 1 14.2774 1.54153 13.3005 2.42996C14.0593 3.60221 14.4999 4.99966 14.4999 6.5Z"
          fill="#000000"
        />
        <path
          d="M0 18C0 15.7909 1.79086 14 4 14H10C12.2091 14 14 15.7909 14 18V22C14 22.5523 13.5523 23 13 23H1C0.447716 23 0 22.5523 0 22V18Z"
          fill="#000000"
        />
        <path
          d="M16 18V23H23C23.5522 23 24 22.5523 24 22V18C24 15.7909 22.2091 14 20 14H14.4722C15.4222 15.0615 16 16.4633 16 18Z"
          fill="#000000"
        />
      </svg>
    ),
    payoutreport: (
      <svg
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M341.333333,0 L426.666667,85.3333333 L426.666667,341.333333 L0,341.333333 L0,0 L341.333333,0 Z 
         M330.666667,42.6666667 L42.6666667,42.6666667 L42.6666667,298.666667 L384,298.666667 L384,96 
         L330.666667,42.6666667 Z 
         M149.333333,234.666667 L149.333333,266.666667 L85.3333333,266.666667 L85.3333333,234.666667 
         L149.333333,234.666667 Z 
         M341.333333,234.666667 L341.333333,266.666667 L192,266.666667 L192,234.666667 
         L341.333333,234.666667 Z 
         M149.333333,170.666667 L149.333333,202.666667 L85.3333333,202.666667 L85.3333333,170.666667 
         L149.333333,170.666667 Z 
         M341.333333,170.666667 L341.333333,202.666667 L192,202.666667 L192,170.666667 
         L341.333333,170.666667 Z 
         M149.333333,106.666667 L149.333333,138.666667 L85.3333333,138.666667 L85.3333333,106.666667 
         L149.333333,106.666667 Z 
         M341.333333,106.666667 L341.333333,138.666667 L192,138.666667 L192,106.666667 
         L341.333333,106.666667 Z"
          fill="#000000"
        />
      </svg>
    ),
    attandence: (
      <svg
        viewBox="0 -0.5 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9238 7.281C14.9227 8.5394 13.9018 9.55874 12.6435 9.558C11.3851 9.55726 10.3654 8.53673 10.3658 7.27833C10.3662 6.01994 11.3864 5 12.6448 5C13.2495 5.00027 13.8293 5.24073 14.2567 5.6685C14.6841 6.09627 14.924 6.67631 14.9238 7.281Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9968 12.919H10.2968C8.65471 12.9706 7.35028 14.3166 7.35028 15.9595C7.35028 17.6024 8.65471 18.9484 10.2968 19H14.9968C16.6388 18.9484 17.9432 17.6024 17.9432 15.9595C17.9432 14.3166 16.6388 12.9706 14.9968 12.919V12.919Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6878 9.02403C20.6872 9.98653 19.9066 10.7664 18.9441 10.766C17.9816 10.7657 17.2016 9.9852 17.2018 9.0227C17.202 8.06019 17.9823 7.28003 18.9448 7.28003C19.4072 7.28003 19.8507 7.4638 20.1776 7.7909C20.5045 8.11799 20.688 8.56158 20.6878 9.02403V9.02403Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.3338 9.02401C4.3338 9.98664 5.11417 10.767 6.0768 10.767C7.03943 10.767 7.8198 9.98664 7.8198 9.02401C7.8198 8.06137 7.03943 7.28101 6.0768 7.28101C5.11417 7.28101 4.3338 8.06137 4.3338 9.02401V9.02401Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4368 12.839C19.0226 12.839 18.6868 13.1748 18.6868 13.589C18.6868 14.0032 19.0226 14.339 19.4368 14.339V12.839ZM20.7438 13.589L20.7593 12.8392C20.7541 12.839 20.749 12.839 20.7438 12.839V13.589ZM20.7438 18.24V18.99C20.749 18.99 20.7541 18.9899 20.7593 18.9898L20.7438 18.24ZM19.4368 17.49C19.0226 17.49 18.6868 17.8258 18.6868 18.24C18.6868 18.6542 19.0226 18.99 19.4368 18.99V17.49ZM5.58477 14.339C5.99899 14.339 6.33477 14.0032 6.33477 13.589C6.33477 13.1748 5.99899 12.839 5.58477 12.839V14.339ZM4.27777 13.589V12.839C4.27259 12.839 4.26741 12.839 4.26222 12.8392L4.27777 13.589ZM4.27777 18.24L4.26222 18.9898C4.26741 18.9899 4.27259 18.99 4.27777 18.99V18.24ZM5.58477 18.99C5.99899 18.99 6.33477 18.6542 6.33477 18.24C6.33477 17.8258 5.99899 17.49 5.58477 17.49V18.99ZM19.4368 14.339H20.7438V12.839H19.4368V14.339ZM20.7282 14.3388C21.5857 14.3566 22.2715 15.0568 22.2715 15.9145H23.7715C23.7715 14.2405 22.4329 12.8739 20.7593 12.8392L20.7282 14.3388ZM22.2715 15.9145C22.2715 16.7722 21.5857 17.4724 20.7282 17.4902L20.7593 18.9898C22.4329 18.9551 23.7715 17.5885 23.7715 15.9145H22.2715ZM20.7438 17.49H19.4368V18.99H20.7438V17.49ZM5.58477 12.839H4.27777V14.339H5.58477V12.839ZM4.26222 12.8392C2.58861 12.8739 1.25 14.2405 1.25 15.9145H2.75C2.75 15.0568 3.43584 14.3566 4.29332 14.3388L4.26222 12.8392ZM1.25 15.9145C1.25 17.5885 2.58861 18.9551 4.26222 18.9898L4.29332 17.4902C3.43584 17.4724 2.75 16.7722 2.75 15.9145H1.25ZM4.27777 18.99H5.58477V17.49H4.27777V18.99Z"
          fill="#000000"
        />
      </svg>
    ),

    // Add more icons here as needed
  };

  return icons[name] || null; // Return the requested icon or null if not found
};

export default Icon;
